export function getVersion() {
  const search = globalThis.location.search;
  if (!search) {
    return 1;
  }
  const params = new URLSearchParams(search);
  const version = params.get('v');
  if (!version) {
    return 1;
  }
  const versionNumber = parseInt(version, 10);
  if (isNaN(versionNumber)) {
    return 1;
  }
  return versionNumber;
}

export function isVersion(target: number) {
  return getVersion() === target;
}
